(() => {
  const root = document.documentElement;
  const motion = matchMedia('(prefers-reduced-motion: reduce)');
  const storageKey = 'evayong-menu-destination';
  const destination = location.pathname + location.search;
  let fromMenu = false;
  try {
    const stored = JSON.parse(sessionStorage.getItem(storageKey) || 'null');
    sessionStorage.removeItem(storageKey);
    fromMenu = stored?.destination === destination && Date.now() - stored.created >= 0 && Date.now() - stored.created < 30000;
  } catch {}

  // Record intent only; ordinary browser navigation remains in charge.
  document.addEventListener('click', event => {
    if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.defaultPrevented) return;
    const link = event.target.closest?.('a[href]');
    if (!link?.closest('ey-home-menu') || link.hasAttribute('download')) return;
    if (link.target && link.target.toLowerCase() !== '_self') return;
    let target;
    try { target = new URL(link.href, location.href); } catch { return; }
    if (target.origin !== location.origin || !/^https?:$/.test(target.protocol)) return;
    const next = target.pathname + target.search;
    if (next === destination) return;
    queueMicrotask(() => {
      if (event.defaultPrevented) return;
      try { sessionStorage.setItem(storageKey, JSON.stringify({ destination: next, created: Date.now() })); } catch {}
    });
  }, true);

  let started = false;
  let restored = false;
  let mainFinished = false;
  let nativeTransition = null;
  let nativeObserved = false;
  let frame = 0;
  let completionTimer = 0;
  let imageTimer = 0;
  let imageController;
  const enteringImages = new Set();

  const isHome = () => document.body?.classList.contains('ey-home');
  const finish = () => {
    cancelAnimationFrame(frame);
    clearTimeout(completionTimer);
    root.dataset.eyPageEntry = 'complete';
    mainFinished = true;
  };
  const clearImages = () => {
    clearTimeout(imageTimer);
    imageController?.abort();
    enteringImages.forEach(image => image.classList.remove('ey-page-entry-image'));
    enteringImages.clear();
  };

  const watchArrivalImages = () => {
    if (!fromMenu || imageController) return;
    imageController = new AbortController();
    const images = [...document.querySelectorAll('#MainContent img')].filter(image => {
      if (image.complete || !image.alt.trim() || image.matches('[aria-hidden="true"], .ey-product__image--alternate, .ey-home-products__image--alternate')) return false;
      const rect = image.getBoundingClientRect();
      return rect.width > 60 && rect.height > 60 && rect.top < innerHeight && rect.bottom > 0;
    }).slice(0, 6);
    images.forEach(image => image.addEventListener('load', () => {
      if (!mainFinished || nativeTransition || restored || motion.matches || document.hidden || !image.isConnected) return;
      enteringImages.add(image);
      image.classList.add('ey-page-entry-image');
      image.addEventListener('animationend', () => {
        image.classList.remove('ey-page-entry-image');
        enteringImages.delete(image);
      }, { once: true, signal: imageController.signal });
    }, { once: true, signal: imageController.signal }));
    // Late photos reveal independently; content is never held while they load.
    imageTimer = setTimeout(clearImages, 3500);
  };

  const fade = () => {
    if (restored || motion.matches || document.hidden || isHome()) { finish(); return; }
    if (started || nativeTransition || nativeObserved || !document.getElementById('MainContent')) return;
    started = true;
    mainFinished = false;
    watchArrivalImages();
    root.dataset.eyPageEntry = 'fade';
    completionTimer = setTimeout(finish, 700);
  };

  const queueEntry = () => {
    if (document.readyState === 'loading' || restored || started || nativeTransition || nativeObserved) return;
    cancelAnimationFrame(frame);
    frame = requestAnimationFrame(() => {
      // Allow the destination's first layout to settle, without waiting for media.
      frame = requestAnimationFrame(() => {
        try {
          if (root.matches(':active-view-transition')) {
            nativeObserved = true;
            root.dataset.eyPageEntry = 'native';
            completionTimer = setTimeout(finish, 700);
            return;
          }
        } catch {}
        fade();
      });
    });
  };

  window.addEventListener('pagereveal', event => {
    if (restored) { finish(); return; }
    if (!event.viewTransition) { queueEntry(); return; }
    const transition = event.viewTransition;
    nativeTransition = transition;
    nativeObserved = true;
    cancelAnimationFrame(frame);
    clearTimeout(completionTimer);
    root.dataset.eyPageEntry = 'native';
    transition.ready.catch(() => {
      if (nativeTransition !== transition) return;
      nativeTransition = null;
      nativeObserved = false;
      started = false;
      queueEntry();
    });
    transition.finished.then(() => {
      if (nativeTransition === transition) finish();
    }, () => {});
  });

  document.addEventListener('DOMContentLoaded', queueEntry, { once: true });
  queueEntry();
  document.addEventListener('animationend', event => {
    if (event.target.id === 'MainContent' && event.animationName === 'ey-page-entry') finish();
  });
  window.addEventListener('pagehide', () => { restored = true; finish(); clearImages(); });
  window.addEventListener('pageshow', event => {
    if (event.persisted) { restored = true; finish(); clearImages(); }
    else if (nativeObserved) finish();
    else queueEntry();
  });
  document.addEventListener('visibilitychange', () => {
    if (document.hidden) { finish(); clearImages(); }
    else queueEntry();
  });
  motion.addEventListener('change', event => { if (event.matches) { finish(); clearImages(); } });
})();
